export default "__VITE_ASSET__e632eaa2__"